import Container from '../components/Layout/Container.js';
import FocusPage from '../components/TodayFocusComponents/FocusPage.js';

function FocusTimerPage() {
  return (
    <>
      <Container>
        <FocusPage />
      </Container>
    </>
  );
}

export default FocusTimerPage;
